import * as z from 'zod'

export const filtersSchema = z.object({
  position: z.object({
    // used to store the position id input from the user, not shipped to the backend
    positionIdUserInput: z.coerce
      .number({
        invalid_type_error: 'Position Id must be a number',
      })
      .min(1, { message: 'Position Id must be a number' })
      .optional(),
    positionIds: z
      .array(
        z.object({
          id: z.number().positive(),
        })
      )
      .optional(),
    status: z.enum(['approved', 'unapproved', 'all']),
    prescreenStatus: z.enum(['prescreened', 'not-prescreened', 'all']),
  }),
  company: z.object({
    // used to store the company id input from the user, not shipped to the backend
    companyIdUserInput: z.coerce
      .number({
        invalid_type_error: 'Company Id must be a number',
      })
      .min(1, { message: 'Company Id must be a number' })
      .optional(),
    companyIds: z
      .array(
        z.object({
          id: z.number().positive(),
        })
      )
      .optional(),
    // used to store the company group id input from the user, not shipped to the backend
    companyGroupIdUserInput: z.coerce
      .number({
        invalid_type_error: 'Company Group Id must be a number',
      })
      .min(1, { message: 'Company Group Id must be a number' })
      .optional(),
    companyGroupIds: z
      .array(
        z.object({
          id: z.number().positive(),
        })
      )
      .optional(),
  }),
})

export type FiltersSchema = z.infer<typeof filtersSchema>
